module.exports = __webpack_public_path__ + "img/75644.20052be6.svg";